"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var scrollbooster_1 = __importDefault(require("scrollbooster"));
/**
 * Returns ref values for the viewport and the scrollbooster instance
 */
var useScrollBoost = function (options) {
    if (options === void 0) { options = {}; }
    var scrollBooster = react_1.useRef();
    // options shouldn't change within the hook but can be changed on the scrollBooster instance
    var optionsRef = react_1.useRef(options);
    var viewport = react_1.useCallback(function (node) {
        if (node) {
            var _a = optionsRef.current, content = _a.content, rest = __rest(_a, ["content"]);
            var sbOptions = __assign({ viewport: node }, rest);
            if (content === null || content === void 0 ? void 0 : content.current) {
                sbOptions.content = content.current;
            }
            // create the scrollbooster instance
            scrollBooster.current = new scrollbooster_1.default(sbOptions);
        }
    }, []);
    react_1.useEffect(function () {
        // clear the scrollbooster eventlisteners
        return function () { var _a; return (_a = scrollBooster.current) === null || _a === void 0 ? void 0 : _a.destroy(); };
    }, []);
    return [viewport, scrollBooster.current];
};
exports.useScrollBoost = useScrollBoost;
function ScrollBoost(_a) {
    var children = _a.children, options = __rest(_a, ["children"]);
    var _b = __read(useScrollBoost(options), 2), viewport = _b[0], scrollbooster = _b[1];
    return react_1.default.createElement(react_1.default.Fragment, null, children({ viewport: viewport, scrollbooster: scrollbooster }));
}
exports.ScrollBoost = ScrollBoost;
//# sourceMappingURL=index.js.map